import { PRDService, ToastService } from '@/services'

const getDefaultState = () => {
    return {
        order: {},
        lblWorkOrders: null,
        lblOrder: null,
        lblAssembly: [],
        newItem: null,
        error: null,
        fetching: false,
        errorAnalysis: null,
        posting: false,
    }
}

const state = getDefaultState()

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
    getOrderDetail({ dispatch, commit }, data) {
        PRDService.getProductionOpenProduct(data)
        .then(({ data }) => {
            commit("setOrder", data)
            dispatch('getLblWorkOrders')
        })
    },
    getLblWorkOrders({ commit, state }) {
        if (!state.order) return

        PRDService.getLblOrdersHeader(state.order.order_number)
        .then(({ data }) => commit("setLblWorkOrders", data))
    },
    getLblWorkHeader({ dispatch, commit, state }, lbl_number) {
        if (!state.order) return

        PRDService.getLblOrderHeader(lbl_number)
        .then(({ data }) => commit("setLblOrder", data))
        .then(() => dispatch("getLblAssemblyWork"))
    },
    getLblAssemblyWork({ state, commit }) {
        if (!state.lblOrder) return

        PRDService.getLblAssemblyItems(state.lblOrder.lbl_number)
        .then(({ data }) => commit('setAssembly', data))
    },
    createLblOrder({ commit, state }) {
        const { order_number, seq_number } = state.order
        if (!order_number) return

        PRDService.createLblOrderHeader(order_number, seq_number)
        .then(({ data }) => commit("setLblOrder", data ))
    },
    saveLblOrder({commit, state}) {
        if (!state.lblOrder) return

        return PRDService.updateLblOrderHeader(state.lblOrder)
        .then(({ data }) => commit("setLblOrder", data ))
    },
    deleteLblOrder({commit, state}) {
        if (!state.lblOrder) return

        PRDService.deleteLblOrder(state.lblOrder.id)
        .then(({ data }) => commit("removeLblOrder", data ))
    },
    async processLblOrder({ state, commit, dispatch}) {
        if (!state.lblOrder) return

        await dispatch('saveLblOrder')

        PRDService.processLblOrder(state.lblOrder.id)
        .then((response) => {
          if (response.data && response.data.errors) {
            commit("setErrorAnalysis", response.data.errors);
          } else {
            ToastService.success("La orden ha sido procesada exitosamente.")
            commit("resetState");
          }
        })
        .finally(() => commit('setPosting', false))
    },
    createLblItem({ commit, state }, product_code) {
        if (product_code === "") return
        if (!state.lblOrder) return

        const { lbl_number, seq_number } = state.lblOrder

        PRDService.createLblOrderAssemblyItem({lbl_number, seq_number, product_code})
        .then(({ data }) => commit("addAssemblyItem", data ))
    },
    updateLblItem({ commit, state }, data) {
        PRDService.updateLblOrderAssemblyItem(data)
        .then(({ data }) => commit("updateAssemblyItem", data ))
    },
    deleteLblItem({ commit,  }, id) {
        PRDService.deleteLblOrderAssemblyItem(id)
        .then(({ data }) => commit("removeLblItem", data ))
    },
    assignLotNumber(context, data) {
        return PRDService.postLblAssemblyLot(data)
        .then(({ status }) => {
            console.log(status)
        })
    },
}

const mutations = {
    resetState: (state) => (Object.assign(state, getDefaultState())),
    setOrder: (state, data) => (state.order = data),
    setLblWorkOrders: (state, data) => (state.lblWorkOrders = data),
    setAssembly: (state, data) => (state.lblAssembly = data),
    addAssemblyItem: (state, data) => (state.lblAssembly.push(data)),
    setLblOrder: (state, data) => (state.lblOrder = data),
    removeLblOrder: (state, id) => {
        state.lblWorkOrders = state.lblWorkOrders.filter(el => el.id !== id)
        state.lblOrder = null
        state.lblAssembly = []
    },
    removeLblItem: (state, id) => {
        state.lblAssembly = state.lblAssembly.filter(el => el.id !== id)
    },
    updateAssemblyItem: (state, data) => {
        let index = state.lblAssembly.findIndex(el => el.id === data.id)

        if (index >= 0) {
            state.lblAssembly[index].qty_rejected = data.qty_rejected
            state.lblAssembly[index].qty_used = data.qty_used
            state.lblAssembly[index].qty_allocated = data.qty_allocated
        }
    },
    set: (state, {key, value}) => {
        if (!state.lblOrder) return
        state.lblOrder[key] = value
    },
    setErrorAnalysis: (state, errorAnalysis) =>
    (state.errorAnalysis = errorAnalysis),
    setPosting: (state, payload) => (state.posting = payload)
}

const getters = {
    loaded: state => {
        return state.order.id ? true : false
    },
    id: state => () => {
        return state.order.id ? state.order.id : 0
    },
    newRow: state => {
        return state.newRow ? state.newRow : {}
    }
}

export const prdLabeling = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/prd.labeling.module.js